import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import { tableColumnTypes } from "../../tableColumnTypes";
import { createNewEvent } from "./createNewEvent";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { FormattedMessage } from "react-intl";

export let eventMyDrafts = {
  label: <FormattedMessage id="MYCLASS_DRAFTCLASSESNEW" />,
  path: (tenantName) => `/${tenantName}/events/myDrafts`,
  searchPlaceHolder: "Search My Drafts by Event Name",
  columns: (navigate, handleDeleteModal, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="EVENT_NAME_TEXT" />,
      fieldName: "Name",
      // value: (row) => row.Name,
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MyClassStatus_lbl" />,
      fieldName: "StatusText",
      value: (row) => row.StatusText,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip content={<FormattedMessage id="MYCLASS_DELETE" />} direction={"bottom"}>
            <span onClick={() => handleDeleteModal(row.ID)}>
              <DeleteIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction={"bottom"}>
            <span
              onClick={() => {
                localStorage.setItem("shotclassTypeFrom", "myDrafts");
                navigate(`${createNewEvent.editpath(tenantName)}/${row.ID}`, {
                  state: { from: "myDrafts" },
                });
              }}
            >
              <EditIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="MYCLASS_COPY" />} direction={"bottom"}>
            <span
              onClick={() => {
                localStorage.setItem("shotclassTypeFrom", "myDrafts");
                navigate(`${createNewEvent.copypath(tenantName)}/${row.ID}`, {
                  state: { from: "myDrafts" },
                })
              }
              }
            >
              <CopyIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
